import React from "react";
import { observer } from "mobx-react-lite";
import { ICheckbox } from "../../ui-kit";
import { IResourceFormChoice } from "./interface";

import styles from "./DefectForm.module.scss";

const ResourceFormChoice: React.FC<IResourceFormChoice> = observer(
  ({ choices, choice, setChoice }) => {
    const onChoiceClick = (e) => {
      const checkedChoice = choices.find((c) => c.id === e.target.value);
      setChoice(checkedChoice);
    };

    return (
      <div className={styles.choices}>
        {choices.map((c) => (
          <div key={c.id} className={styles.choice}>
            <ICheckbox
              value={c.id}
              checked={choice.id === c.id}
              onChange={(e) => onChoiceClick(e)}
              label={c.title}
              disabled={choice.id === c.id}
            />
          </div>
        ))}
      </div>
    );
  },
);

export default ResourceFormChoice;
